export default __webpack_public_path__ + "static/media/notificationsBlack.c7242c89.svg";